
import { reactive, onBeforeMount, getCurrentInstance, computed, ComputedRef } from "vue";
import { ElLoading, ElMessage } from "element-plus";
import { useRouter } from "vue-router";

export default {
  setup() {
    const data: any = reactive({
      keyword: "",
      idCard: "",
      list: [],
      pageSize: 20,
      pageNum: 1,
    });

    const router = useRouter();
    const totalPrice: ComputedRef<Number> = computed(() => {
      return data.list.reduce((total: number, item: any) => {
        const currentAmount: number = Number(item.awaitPayment);
        if (item.checked) {
          total += currentAmount;
        }
        return total;
      }, 0);
    });

    const baseUrl = getCurrentInstance()?.appContext.config.globalProperties.$baseUrl;
    let loading: any = null;

    function doSearch(): void {
      startLoading();
      fetch(
        `${baseUrl}/internalOrder/order/listOpen?studentName=${data.keyword}&IDNumber=${data.idCard}&pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then((res) => {
          res.rows.forEach((o: any) => {
            o.checked = false;
            o.awaitPayment = Number(o.awaitPayment / 100).toFixed(2);
          });
          data.list = res.rows;
        })
        .catch((err) => {
          ElMessage.error(err);
        })
        .finally(() => {
          stopLoading();
        });
    }

    // onBeforeMount(() => {
    //   doSearch();
    // });

    function startLoading(): void {
      loading = ElLoading.service();
    }

    function stopLoading(): void {
      loading.close();
    }

    function scrollToLower(e: Event): void {
      const eventTarget = e.target as Element;
      if (eventTarget.scrollTop + eventTarget.clientHeight >= eventTarget.scrollHeight) {
        console.log("reach bottom");
      }
    }

    function pickAll(): void {
      data.list.forEach((o: any) => {
        o.checked = o.paymentState == 0;
      });
    }

    function unpickAll(): void {
      data.list.forEach((o: any) => {
        o.checked = false;
      });
    }

    function submit(): void {
      if (totalPrice.value === 0) {
        ElMessage.error("请选择订单");
        return;
      } else {
        const selectedList: Array<any> = data.list.filter((o: any) => o.checked);
        router.push({
          name: "confirmOrder",
        });
        window.localStorage.setItem(
          "orderInfo",
          JSON.stringify({
            selectedList: selectedList,
            searchParamter: {
              ...data,
            },
          })
        );
      }
    }

    return {
      data,
      totalPrice,
      doSearch,
      scrollToLower,
      submit,
      pickAll,
      unpickAll,
    };
  },
};
